import { Box, CircularProgress } from "@mui/material";

interface IProps {
  loading: boolean;
}
const pageLoader = ({ loading }: IProps) => {
  return loading ? (
    <div className="loading-indicator">
      <Box className="progress-bar">
        <CircularProgress />
      </Box>
    </div>
  ) : null;
};
export default pageLoader;
